import React from 'react';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {
  getGlobalSettingValue,
  getItemOfSessionStorage,
} from '../../services/common/utils';
import { IS_2FA_DONE } from '../../services/common/Constants';
import {
  setAuthModalContent,
  setClicked2FAData,
  setShowAuthModal,
  setShowEnableMediumAuthBtn,
  setShowGetKuwaitAppBtn,
} from '../../reducer/utilitySlice';
import { useSelector, useDispatch } from 'react-redux';

const TransactionCard = ({ data, icon }) => {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const {
    utilityData: { globalSetting },
  } = useSelector((state) => state);

  const msisdn =
    data?.msisdn_b.substring(0, 3) === '965'
      ? data?.msisdn_b.substr(3)
      : data?.msisdn_b;

  const handleTransferBalance = () => {
    navigate('/transfer-balance');
  };

  const handle2FA = () => {
    // if 2fa is done
    if (getItemOfSessionStorage(IS_2FA_DONE) === 'true') {
      handleTransferBalance();

      // if 2fa is pending
    } else {
      dispatch(setShowEnableMediumAuthBtn(false));
      dispatch(setShowGetKuwaitAppBtn(false));

      const requiredRedirectData = {
        url: '/transfer-balance',
        state: null,
      };
      dispatch(setClicked2FAData(requiredRedirectData));
      dispatch(setShowAuthModal(true));

      const settingsArr = globalSetting
        ? globalSetting?.Globalsettings[0]?.items[0]?.metadata
        : [];

      dispatch(
        setAuthModalContent({
          icon: getGlobalSettingValue('beforeverificationicon_web', settingsArr),
          title: getGlobalSettingValue('beforeverificationtitle', settingsArr),
          message: getGlobalSettingValue('beforeverificationmsg', settingsArr),
          btnText: getGlobalSettingValue(
            'beforeverificationbuttontext',
            settingsArr
          ),
        })
      );
    }
  };

  return (
    <div class="card_style_2 mb-3">
      <div class="card_img">
        <img
          src={icon || process.env.PUBLIC_URL + 'assets/images/s-internet.svg'}
          alt=""
        />
      </div>
      <div class="card_info">
        <div class="card_info_grp">
          <div class="d-flex  justify-content-between">
            <div>
              <h4 class="text-ellipsis">{msisdn}</h4>
              <p className='dir-ltrl'>{moment(data?.datetime).format('DD-MMM-YYYY')}</p>
            </div>
            <h4 class="text-ellipsis">{`${t("kd")} ${data?.amount}`}</h4>
          </div>
        </div>
        <div class="card_link flex_grp_align_center">
          <a
            href="#"
            class="hyperlink"
            onClick={(e) => {
              e.preventDefault();
              handle2FA();
            }}
          >
            {data?.buttontext}
            <img
              src={process.env.PUBLIC_URL + '/assets/images/right_arrow_red.svg'}
              class="ms-1"
              alt=""
            />
          </a>
        </div>
      </div>
    </div>
  );
};

export default TransactionCard;
